import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { InputComponent, RtTextInput } from '@recruitee/user-interface';

@Component({
  selector: 'rti-subdomain-input',
  templateUrl: './subdomain-input.component.html',
  styleUrls: ['./subdomain-input.component.less'],
  standalone: true,
  imports: [InputComponent, TranslatePipe],
})
export class SubdomainInputComponent extends RtTextInput {
  @Input() public prefix: string;
  @Input() public suffix: string;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter();

  @ViewChild('inputComponent', { static: true }) public inputComponent: InputComponent;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.setValue(this.value);
    }
  }

  public handleChange(value: string): void {
    const processedValue = this.processedValue(value);

    this.valueChange.emit(processedValue);
    this.setValue(processedValue);
  }

  public getNativeInputElement(): HTMLInputElement {
    return this.inputComponent.input.nativeElement;
  }

  protected setValue(value: string | null): void {
    this.inputComponent.input.nativeElement.value = value || '';

    // @ts-ignore
    if (!this.cdRef['destroyed']) {
      this.cdRef.detectChanges();
    }
  }

  private prefixEndIndex(value: string): number {
    if (value.startsWith(this.prefix)) {
      return this.prefix.length;
    } else {
      return 0;
    }
  }

  private suffixStartIndex(value: string): number | undefined {
    const suffixIndex = value.indexOf(this.suffix);

    if (suffixIndex !== -1) {
      return suffixIndex;
    } else {
      return undefined;
    }
  }

  private processedValue(value: string | null): string {
    if (value) {
      return value.substring(this.prefixEndIndex(value), this.suffixStartIndex(value));
    } else {
      return '';
    }
  }
}
